import { render, staticRenderFns } from "./Crypto.vue?vue&type=template&id=4719a58e&scoped=true"
import script from "./Crypto.vue?vue&type=script&lang=js"
export * from "./Crypto.vue?vue&type=script&lang=js"
import style0 from "./Crypto.vue?vue&type=style&index=0&id=4719a58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719a58e",
  null
  
)

export default component.exports